import { Icon } from '@testsigma/atoms';

interface ProfileDropDownItemPros {
  onClick: () => void;
  icon: string;
  text: string;
}

export const ProfileDropDownItem: React.FC<ProfileDropDownItemPros> = ({
  onClick,
  icon,
  text,
}) => {
  return (
    <div
      onClick={onClick}
      className={
        'px-3 py-2 flex item-center text-small leading-5 hover:bg-secondary-50 cursor-pointer text-unique-600 rounded'
      }>
      <Icon className={'pr-2 text-[18px]'} name={icon} />
      {text}
    </div>
  );
};
